export default __webpack_public_path__ + "static/media/terapias-de-realidad-virtual.7eb2b540.jpg";